import { useEffect, useState } from "react";
import { HiOutlineX } from "react-icons/hi";
import { Link } from "react-router-dom";
import { clearCartItems, getCartItems, setCartItems } from "utils/cartStorage";

const QuickAddDrawer = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);

  const increaseQuantity = (index) => {
    const updated = [...products];
    updated[index].quantity = (updated[index].quantity || 1) + 1;
    setProducts(updated);
    updateLocalStorage(updated);
  };

  const decreaseQuantity = (index) => {
    const updated = [...products];
    if ((updated[index].quantity || 1) > 1) {
      updated[index].quantity -= 1;
      setProducts(updated);
      updateLocalStorage(updated);
    }
  };
  useEffect(() => {
    if (isOpen) {
      setLoading(true);
      setTimeout(() => {
        const storedItems = getCartItems();
        setProducts(storedItems);
        setLoading(false);
      }, 500);
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable scroll
      document.body.style.overflow = "auto";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const updateLocalStorage = (updatedProducts) => {
    setCartItems(updatedProducts);
  };

  const removeItem = (index) => {
    const updated = products.filter((_, i) => i !== index);
    setProducts(updated);
    updateLocalStorage(updated);
  };

  const subtotal = products.reduce(
    (total, item) =>
      total +
      (item.selectedVariant?.flashPrice || item.selectedPrice || 0) *
        (item.quantity || 1),
    0,
  );

  return (
    <div>
      {isOpen && (
        <div
          className="fixed inset-0  bg-black/50 z-30 transition-opacity duration-300"
          onClick={onClose}
        ></div>
      )}

      <div
        className={`fixed right-0 z-40 md:w-96 w-[75%] bg-white transform transition-transform duration-300 
  ${isOpen ? "translate-x-0" : "translate-x-full"} 
  md:top-[88px]  md:h-[calc(100dvh-88px)] top-[80px] h-[calc(100dvh-80px)]`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-300 sticky top-0 bg-white z-10">
          <h2 className="text-base md:text-lg font-bold text-black uppercase">
            Shopping Cart
          </h2>
          <button
            onClick={onClose}
            className="text-black md:text-2xl text-lg hover:text-red-500"
          >
            ✖
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-4 pb-32 space-y-4 h-[calc(100vh-128px)]">
          {loading ? (
            <div className="flex justify-center items-center text-[#265fc9] p-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#265fc9]"></div>
            </div>
          ) : products.length === 0 ? (
            <div className="text-center py-10 text-gray-600 font-medium">
              কোনো প্রোডাক্ট কার্টে যুক্ত করা হয়নি
            </div>
          ) : (
            products.map((item, index) => (
              <div key={index} className="flex gap-3 mt-4 relative">
                <div className="relative">
                  <img
                    src={`https://backend.nuhababy.com/${item.selectedVariant?.images?.[0].thumb}`}
                    alt={item.selectedVariant?.title}
                    className="w-20 h-20 object-top object-cover border rounded"
                  />
                  <button
                    onClick={() => removeItem(index)}
                    className="absolute top-0 left-0 bg-white font-bold text-red-500 hover:text-red-700 hover:bg-gray-100 rounded-full p-1 shadow-2xl shadow-gray-400/70 transition-all duration-200 scale-90 hover:scale-100"
                  >
                    <HiOutlineX className="w-4 h-4" />
                  </button>
                </div>
                <div className="flex flex-col flex-1">
                  <p className="text-xs md:text-base font-bold leading-[16px] tracking-wide">
                    {item.selectedVariant?.title || item.selectedTitle}
                  </p>
                  <div className="flex justify-between font-semibold mt-2 text-sm md:text-base">
                    <div className="flex items-center">
                      <button
                        onClick={() => decreaseQuantity(index)}
                        disabled={(item.quantity || 1) <= 1}
                        className="border px-3 md:py-3 py-1 text-gray-500 font-semibold"
                      >
                        -
                      </button>
                      <span className="border px-3 md:py-3 py-1 text-gray-500 font-semibold">
                        {item.quantity || 1}
                      </span>
                      <button
                        onClick={() => increaseQuantity(index)}
                        className="border px-3 md:py-3 py-1 text-gray-500 font-semibold"
                      >
                        +
                      </button>
                    </div>

                    <span className="text-[#265fc9]">
                      {" "}
                      {item.selectedVariant.flashPrice} ৳
                    </span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {!loading && products.length > 0 && (
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-white border-t">
            <div className="flex justify-between items-center text-sm font-medium mb-3">
              <span className="md:text-xl text-xs font-bold">SUBTOTAL:</span>
              <span className="font-bold md:text-xl text-xs text-[#265fc9]">
                {" "}
                {subtotal.toFixed(2)}{" "}
                <span className="text-md font-bold"> ৳</span>{" "}
              </span>
            </div>
            <div>
              <div className="mb-3">
                <Link to={"/cart"}>
                  <button className="w-full font-bangla bg-[#265fc9] text-white font-semibold py-3 rounded md:text-base text-sm">
                    কার্ট দেখুন
                  </button>
                </Link>
              </div>
              <div>
                <Link to={"/orderDetails"}>
                  <button className="w-full font-bangla bg-[#FF0000] text-white font-semibold py-3 rounded md:text-base text-sm">
                    অর্ডার
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuickAddDrawer;
